import styled from 'styled-components'
import "react-datepicker/dist/react-datepicker.css";

export const Form = styled.form`
    position: relative;
    padding-bottom: 5rem;

    label {
        font-size: 0.8rem;
        color: black;
        line-height: 2;
        margin-right: 4%;
    }
`

export const Line = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`

export const InputField = styled.input`
    font-family: 'Montserrat';
    font-size: 0.9rem;
    padding-left: 0.8rem;

    display: block;
    border-style: solid;
    border-width: 1.5px;
    border-radius: 3px;
    border-color: rgb(200, 200, 200);
    transition: ease .5s;

    width: 98%;
    height: 2.2rem;

    &:hover{
        border-color: rgb(170, 170, 170);
        transition: ease .2s;
    }

    &:focus{
        outline-color: rgb(38, 125, 255);
    }
`

export const SelectorContainer = styled.div`
    display: inline-block;
    width: 100%;
    margin-bottom: 1rem;
`

export const ButtonContainer = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    margin-top: 3rem;
`

export const DatePickerStyle = styled.div`
    display: inline-block;
    width: 43.4%;

    &:first-of-type {
        margin-right: 5%;
    }

    .react-datepicker-wrapper, 
    .react-datepicker__input-container {
        width: 100% !important;
    }

    input {
        height: 2rem;
        width: 100%;

        border-style: solid;
        border-width: 1.5px;
        border-radius: 3px;
        border-color: rgb(200, 200, 200);
        transition: ease .5s;

        font-family: 'Montserrat';
        padding-left: 1rem;

    }

    input:hover{
        border-color: rgb(170, 170, 170);
        transition: ease .2s;
    }

    input:focus{
        outline-color: rgb(38, 125, 255);
    }

    @media (max-width: 700px) {
        display: block;
        width: 60%
    }
`